import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import useMainContentDimensions from "../../../utils/mainContentDimensions";
import EditDelete from "../../../components/EditDelete";

import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import usePaidInvoice from "../../../hooks/usePaidInvoice";
import AdvanceFilter from "./components/AdvanceFilter";
import useAuth from "../../../hooks/useAuth";
import PaidToUnpaid from "./components/PaidToUnpaid";
import ReceiptForm from "../../users/user_details/ReceiptPage";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function PaidInvoice(props) {
  const navigate = useNavigate();
  const { user } = useAuth();

  console.log(user, "llllllllllllll");
  const { isLoadingDownload, downloadFileType } = usePaidInvoice();
  const { width: mainContentWidth } = useMainContentDimensions();

  const { state } = useLocation();
  const { t } = useTranslation();

  const { radUserId } = props;

  const [options, setOptions] = useState(["invoice_view", "receipt"]);

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  useEffect(() => {
    if (radUserId != undefined) {
      const payloadValues = {
        ...currentPayload,
        filters: [
          {
            fieldName: "radUserId",
            fieldValue: radUserId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
            attributeName: "radUser",
            entityName: "RadUserEntity",
          },
        ],
      };
      setPayload(payloadValues);
    } else {
      setPayload(currentPayload);
    }
  }, [radUserId]);

  useEffect(() => {
    if (
      user &&
      (user.businessType == "MULTI_SERVICE_OPERATOR" || user.businessType == "SUPER_ADMIN")
    ) {
      setOptions(["invoice_view", "paid_to_unpaid", "receipt"]);
    }
  }, [user]);

  // useEffect(() => {
  //   if (user != undefined && user.businessType == "USER") {
  //     const payloadValues = {
  //       ...currentPayload,
  //       filters: [
  //         {
  //           fieldName: "radUserId",
  //           fieldValue: user.radUserId,
  //           op: "eq",
  //           dataType: "int",
  //           condition: "and",
  //           isJoin: true,
  //           attributeName: "radUser",
  //           entityName: "RadUserEntity",
  //         },
  //       ],
  //     };
  //     setPayload(payloadValues);
  //   } else {
  //     setPayload(currentPayload);
  //   }
  // }, [user]);

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const { getPaidInvoice, getAllPaidInvoice, paidInvoices, isLoading, paging, downloadFile } =
    usePaidInvoice();

  const { totalNumberOfRecords, hasNextPage, pageNumber, pageSize } = paging;
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState({});

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    if (Object.keys(payload).length != 0) {
      await getAllPaidInvoice(payload);
    }
  };

  const refreshPage = () => {
    if (radUserId != undefined) {
      const payloadValues = {
        ...currentPayload,
        filters: [
          {
            fieldName: "radUserId",
            fieldValue: radUserId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
            attributeName: "radUser",
            entityName: "RadUserEntity",
          },
        ],
      };
      setPayload(payloadValues);
    } else {
      setPayload(currentPayload);
    }
    filterResetFunc();
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  const paginationMetaRef = useRef();

  // Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
  const paginationMeta = React.useMemo(() => {
    if (hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== hasNextPage) {
      paginationMetaRef.current = { hasNextPage };
    }
    return paginationMetaRef.current;
  }, [hasNextPage]);

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Invoices</Typography>
        <Typography>Paid</Typography>
      </Breadcrumbs>
    );
  };
  const viewInvoice = (id) => {
    navigate("/user/invoice", { state: { id: id } });
  };

  const changePaidToUnpaid = (renewId, title) => {
    if (title == "receipt") {
      return openDialog(
        "receipt",
        "Receipt",
        <ReceiptForm key={getTimeStamp()} renewId={renewId} />,
        "md",
      );
    } else {
      return openDialog(
        "paid_to_unpaid",
        "Paid to Unpaid",
        <PaidToUnpaid key={getTimeStamp()} renewId={renewId} refreshPage={refreshPage} />,
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete
            rowClick={onClick}
            clickIcon={() => viewInvoice(params.id)}
            editPage={changePaidToUnpaid}
            menus={options}
            rowId={params.id}
          />
        );
      },
    },
    {
      field: "invoiceNo",
      headerName: "Invoice No",
      width: 130,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 300,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      width: 130,
    },
    {
      field: "address",
      headerName: "Address",
      width: 300,
    },
    {
      field: "invoiceDate",
      headerName: "Invoice Date",
      width: 200,
    },
    {
      field: "paidDate",
      headerName: "Paid Date",
      width: 200,
    },
    {
      field: "finalInvoiceAmount",
      headerName: "Invoice Amount",
      width: 130,
    },
    {
      field: "paidAmount",
      headerName: "Paid Amount",
      width: 130,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            downloadFile={(type) => downloadFile(type, payload)}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {t("paid_invoices")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={paidInvoices}
            refreshPage={fetchData}
            getRowId={(row) => row["renewId"]}
            rowCount={paging.totalNumberOfRecords}
            loading={isLoading}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            paginationMeta={paginationMeta}
            pageSizeOptions={[25, 50, 100]}
            sortingMode="server"
            sortModel={sortModel}
            onPaginationModelChange={onPageChange}
            onSortModelChange={handleSortModelChange}
            paginationModel={paginationModel}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default PaidInvoice;
